export interface PressMention {
  /** The outlet as it should be written. */
  outlet: string
  /**
   * The official logo, taken from the outlet's own press or brand kit and hosted
   * by us. When this is empty the outlet is set as a wordmark in its brand
   * colour instead, so nothing is claimed through artwork we do not hold.
   */
  logoUrl: string
  /** The outlet's brand colour, used for the wordmark and the card rule. */
  brandColour: string
  /** The headline of the coverage. */
  headline: string
  /** A short pull line from the piece. */
  excerpt: string
  /** ISO date of publication. */
  publishedAt: string
  /**
   * The canonical URL of the coverage. Leave empty until the piece is live: an
   * entry with no URL is not presented as a link, so the site never points a
   * reader at coverage that does not exist.
   */
  url: string
}

/**
 * Press coverage, newest first.
 *
 * Every entry is a factual claim about the real world, so each one must be
 * traceable to a published piece before launch. Add the URL as each placement
 * goes live, and the logo once it is taken from the outlet's own brand kit.
 */
export const PRESS_MENTIONS: PressMention[] = [
  {
    outlet: 'Yahoo Finance',
    logoUrl: '',
    brandColour: '#7B5CFA',
    headline: 'Cavalla Solution launches an augmented intelligence practice for African markets',
    excerpt:
      'The firm is betting that data foundations, not model access, decide which institutions gain from AI.',
    publishedAt: '2026-08-18',
    url: '',
  },
  {
    outlet: 'Business Insider Africa',
    logoUrl: '',
    brandColour: '#4DA8FF',
    headline: 'Why data foundations, not model access, decide who gains from AI in Africa',
    excerpt:
      'Institutions that fix governance and data quality first capture disproportionate value from adoption.',
    publishedAt: '2026-08-12',
    url: '',
  },
  {
    outlet: 'MarketWatch',
    logoUrl: '',
    brandColour: '#3AC569',
    headline: 'Africa AI market projected at 16.5 billion dollars by 2030',
    excerpt: 'Growth is concentrated in banking, health and government, where the data already exists.',
    publishedAt: '2026-07-30',
    url: '',
  },
  {
    outlet: 'Benzinga',
    logoUrl: '',
    brandColour: '#FF6B4A',
    headline: 'Cavalla Gov brings national plan delivery reporting onto one platform',
    excerpt:
      'Ministries of finance get one live view across every agency, with AI drafted reports approved by a named official.',
    publishedAt: '2026-07-22',
    url: '',
  },
  {
    outlet: 'African Business',
    logoUrl: '',
    brandColour: '#FFB03A',
    headline: 'Governments are measured on delivery, and most cannot see it',
    excerpt:
      'In one recent first year of delivery, a third of a plan’s interventions could not be rated at all.',
    publishedAt: '2026-07-09',
    url: '',
  },
]
